import request from "@/utils/request";
// 测试接口
export function GetVerifyCode(params) {
  return request({
    url: "/h5/Index/getVerifyCode",
    method: "post",
    params,
  });
}
// 提交手机号
export function BindingMobile(params) {
  return request({
    url: "/h5/Index/bindingMobile",
    method: "post",
    params,
  });
}
// 获取老板是否绑定手机号
export function GetMobileBindStatus(params) {
  return request({
    url: "/h5/Index/getMobileBindStatus",
    method: "post",
    params,
  });
}

